import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import Writer from "./pages/writer";
import Director from "./pages/director";
import Actor from "./pages/actor";
import Producer from "./pages/producer";
import Editor from "./pages/editor";
import Notfound from "./pages/404";

import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			<Routes>
				<Route path="/" element={<Homepage />} />
				<Route path="/writer" element={<Writer />} />
				<Route path="/director" element={<Director />} />
				<Route path="/actor" element={<Actor />} />
				<Route path="/producer" element={<Producer />} />
				<Route path="/editor" element={<Editor />} />
				<Route path="*" element={<Notfound />} />
			</Routes>
		</div>
	);
}

export default App;
